module.exports = __webpack_public_path__ + "static/media/tech.dc32edc3.svg";